import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { DataSharedService } from '../services/data-shared.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../services/user.service';
import { ClientService } from '../services/client.service';
import { AlertModal, SuccessModal } from '../app.model';
import { AlertModalComponent } from '../components/alert-modal/alert-modal.component';
import { SuccessModalComponent } from '../components/success-modal/success-modal.component';


@Component({
  selector: 'app-client-contacts',
  templateUrl: './client-contacts.component.html',
  styleUrls: ['./client-contacts.component.css']
})

export class ClientContactsComponent implements OnInit {
  @Input() client: any;
  @Output() activateEditClientContactModal: EventEmitter<any> = new EventEmitter();
  @Output() deactivateEditClientContactModal: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  saving: boolean = false;
  clientContacts: any = [];
  allClientContacts: any = [];

  active_client: number = 1;
  active_contact: number = 1;

  view: 'list' | 'edit' = 'list';
  editing: any = null;
  private editingSnapshot: string = '';

  @ViewChild('listScroller') listScroller?: ElementRef<HTMLElement>;

  emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  constructor(
    private route: ActivatedRoute,
    public dataSharedService: DataSharedService,
    public authService: AuthenticationService,
    public activeModalService: NgbActiveModal,
    public userService: UserService,
    private clientService: ClientService,
    private modalService: NgbModal,
  ) {

    this.allClientContacts = []
    this.clientContacts = []
    if (this.route.snapshot.queryParams['client']) {
      this.client = JSON.parse(this.route.snapshot.queryParams['client']);

      this.clientContacts = this.client.contacts;
      this.allClientContacts = this.clientContacts.slice();

      this.active_client = this.client.active_client;
      this.active_contact = this.client.active_contact;
    }
  }

  ngOnInit(): void {
    if (this.client) {
      this.clientContacts = this.client.contacts;
      this.allClientContacts = this.clientContacts.slice();
    }
  }

  // Modal custom update data
  updateData(data: any): void {
    if (data?.client) {
      this.client = data?.client;
      this.clientContacts = this.client.contacts;
      this.allClientContacts = this.clientContacts.slice();
    }
    this.loading = false;
  }

  onClose() {
    this.activeModalService.close();
  }

  isContactActive(c: any): boolean {
    if (!c) return false;
    const v = c.active != null ? c.active : c.is_active;
    return v === 1 || v === '1' || v === true;
  }

  get activeContacts(): any[] {
    return (this.clientContacts || []).filter((c: any) => this.isContactActive(c));
  }

  dayName(d: number | null | undefined): string {
    if (d == null) return '';
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d] || '';
  }

  trackByContact(_: number, c: any): any {
    return c?.uuid || c?.email || c;
  }

  rowClick(contact: any, event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target && target.closest('.row-action')) return;
    this.openEditView(contact);
  }

  openAddView() {
    const blank = {
      uuid: null,
      first_name: '',
      last_name: '',
      email: '',
      active: 1,
      send_invite: true,
      timesheet_notification_settings: {
        email_type: 0,
        frequency: 1,
        day: 5,
        time: '17:00',
      },
    };
    this.editing = blank;
    this.editingSnapshot = JSON.stringify(blank);
    this.view = 'edit';
  }

  openEditView(contact: any) {
    const cloned = JSON.parse(JSON.stringify(contact));
    cloned.timesheet_notification_settings = cloned.timesheet_notification_settings || {
      email_type: 0,
      frequency: 1,
      day: 5,
      time: '17:00',
    };
    if (cloned.timesheet_notification_settings.email_type == null) {
      cloned.timesheet_notification_settings.email_type = 0;
    }
    if (cloned.timesheet_notification_settings.frequency == null) {
      cloned.timesheet_notification_settings.frequency = 1;
    }
    if (cloned.timesheet_notification_settings.day == null) {
      cloned.timesheet_notification_settings.day = 5;
    }
    if (!cloned.timesheet_notification_settings.time) {
      cloned.timesheet_notification_settings.time = '17:00';
    }
    if (cloned.send_invite == null) cloned.send_invite = false;
    cloned.active = this.isContactActive(cloned) ? 1 : 0;
    this.editing = cloned;
    this.editingSnapshot = JSON.stringify(cloned);
    this.view = 'edit';
  }

  private isDirty(): boolean {
    if (!this.editing) return false;
    return JSON.stringify(this.editing) !== this.editingSnapshot;
  }

  cancelEdit() {
    if (!this.isDirty()) {
      this.editing = null;
      this.editingSnapshot = '';
      this.view = 'list';
      return;
    }
    const modalRef = this.modalService.open(AlertModalComponent, {
      size: 'md',
      backdrop: false,
      modalDialogClass: 'alert-modal modal-dialog-centered',
    });
    const data: AlertModal = {
      message: 'Discard unsaved changes to this contact?',
      yesAction: 'Discard',
      yesActionColor: '#0566EA',
      noAction: 'Keep editing',
      noActionColor: 'transparent',
    };
    modalRef.componentInstance.data = data;
    modalRef.result.then((res) => {
      if (res?.action === 'yes') {
        this.editing = null;
        this.editingSnapshot = '';
        this.view = 'list';
      }
    });
  }

  setEmailType(type: number) {
    if (!this.editing) return;
    this.editing.timesheet_notification_settings = this.editing.timesheet_notification_settings || {};
    this.editing.timesheet_notification_settings.email_type = type;
  }

  toggleSendInvite() {
    if (!this.editing) return;
    this.editing.send_invite = !this.editing.send_invite;
  }

  toggleActive() {
    if (!this.editing) return;
    const wasOn = this.editing.active === 1 || this.editing.active === true;
    this.editing.active = wasOn ? 0 : 1;
  }

  isInvalid(field: 'first_name' | 'last_name' | 'email'): boolean {
    if (!this.editing) return false;
    const v = (this.editing[field] || '').toString().trim();
    if (!v) return true;
    if (field === 'email') return !this.emailRegex.test(v);
    return false;
  }

  get formValid(): boolean {
    if (!this.editing) return false;
    return !this.isInvalid('first_name') && !this.isInvalid('last_name') && !this.isInvalid('email');
  }

  contactInitials(contact: any): string {
    const name = `${contact?.first_name || ''} ${contact?.last_name || ''}`.trim() || contact?.name || '';
    return (this.authService.getInitials(name) || '?').toUpperCase();
  }

  saveEdit() {
    if (!this.editing || !this.formValid || this.saving) return;
    this.saving = true;

    const updatedContact = {
      ...this.editing,
      first_name: (this.editing.first_name || '').trim(),
      last_name: (this.editing.last_name || '').trim(),
      email: (this.editing.email || '').trim(),
      name: `${(this.editing.first_name || '').trim()} ${(this.editing.last_name || '').trim()}`.trim(),
    };

    const existing = this.client?.contacts || [];
    const isNew = !updatedContact.uuid;
    const updatedContacts = isNew
      ? [...existing, updatedContact]
      : existing.map((c: any) => (c.uuid === updatedContact.uuid ? updatedContact : c));

    const payload: any = {
      client: {
        name: this.client?.name,
        identifier: this.client?.identifier,
        payment_terms: this.client?.payment_terms,
        is_vat_applicable: this.client?.is_vat_applicable,
        client_company_number: this.client?.client_company_number,
        currency_format: this.client?.currency_format,
        client_reference: this.client?.client_reference,
        invoice_email: this.client?.invoice_email || '',
      },
      client_contacts: updatedContacts,
      address: {
        address_1: this.client?.address?.address_1,
        address_2: this.client?.address?.address_2,
        post_zip_code: this.client?.address?.post_zip_code,
        country: this.client?.address?.country,
      },
    };

    this.clientService.updateClient(this.client?.uuid, payload).subscribe({
      next: () => {
        this.refreshAfterSave(updatedContacts);
      },
      error: () => {
        this.saving = false;
      },
    });
  }

  private refreshAfterSave(fallbackContacts: any[]) {
    this.clientService.getClientByIDWithFilter(this.client?.uuid, {
      active_client: this.active_client,
      active_contact: this.active_contact,
    }).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.client = res.data;
          this.clientContacts = this.client.contacts || [];
          this.allClientContacts = this.clientContacts.slice();
        } else {
          this.clientContacts = fallbackContacts;
          this.allClientContacts = fallbackContacts.slice();
        }
        this.saving = false;
        this.editing = null;
        this.editingSnapshot = '';
        this.view = 'list';
        this.scrollListToTop();
        this.flashSuccess('Contact updated.');
      },
      error: () => {
        this.clientContacts = fallbackContacts;
        this.allClientContacts = fallbackContacts.slice();
        this.saving = false;
        this.editing = null;
        this.editingSnapshot = '';
        this.view = 'list';
        this.scrollListToTop();
        this.flashSuccess('Contact updated.');
      },
    });
  }

  private scrollListToTop() {
    setTimeout(() => {
      if (this.listScroller?.nativeElement) {
        this.listScroller.nativeElement.scrollTop = 0;
      }
    }, 0);
  }

  removeContact() {
    if (!this.editing?.uuid) return;
    const target = this.editing;
    const modalRef = this.modalService.open(AlertModalComponent, {
      size: 'md',
      backdrop: false,
      modalDialogClass: 'alert-modal modal-dialog-centered',
    });
    const data: AlertModal = {
      message: `Remove ${target.first_name || target.name || 'this contact'} from ${this.client?.name || 'this client'}?`,
      yesAction: 'Remove',
      yesActionColor: '#f04e5c',
      noAction: 'Cancel',
      noActionColor: 'transparent',
    };
    modalRef.componentInstance.data = data;
    modalRef.result.then((res) => {
      if (res?.action === 'yes') {
        this.saving = true;
        this.userService.deactivateUserAccount(target.uuid).subscribe({
          next: () => {
            this.saving = false;
            this.activeModalService.close({ refresh: true });
          },
          error: () => {
            this.saving = false;
          },
        });
      }
    });
  }

  activateClientContact(client: any, contact: any) {
    this.loading = true;
    this.activateEditClientContactModal.emit({ client, contact });
  }

  deactivateClientContact(client: any, contact: any) {
    this.loading = true;
    this.deactivateEditClientContactModal.emit({ client, contact });
  }

  resendAccountActivation(contactUuid: string) {
    const payload = {
      user_uuid: contactUuid,
    }
    this.userService.resendUserLogin(payload).subscribe({
      next: (response) => {
        this.flashSuccess('Account creation mail sent.');
      },
      error: (err) => {
      }
    });
  }

  private flashSuccess(message: string) {
    const modalRef = this.modalService.open(SuccessModalComponent, {
      size: 'sm',
      modalDialogClass: 'success-modal',
      backdrop: false,
    });
    let data: SuccessModal = {
      message: message,
      image: 'assets/img/checkmark.png',
      duration: 1600,
    }
    modalRef.componentInstance.data = data;
  }

  successModal(message: string) {
    this.flashSuccess(message);
  }
}

